//#region IMPORT
import React, { useEffect, useState } from 'react';
import M_TBM_CUSTOM_05 from './M_TBM_CUSTOM_05';
import Global from '../../../../Services/Common/Global';
import Commons from '../../../../Services/Common/Common';
import * as pdfjsLib from 'pdfjs-dist';
import 'pdfjs-dist/build/pdf.worker.entry';
import { useDispatch, useSelector } from 'react-redux';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import dayjs from 'dayjs';
import { useSearch1 } from './M_TBM_CUSTOM_05_Query';
import { useBackStack } from '../../../../Hooks/back/useBackStack';
//#endregion

function M_TBM_CUSTOM_05F(props) {
  //#region 변수
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const activeStep = useSelector((state) => state.common.activeStep);
  const [loading, setLoading] = useState(false);
  const [pdfImages, setPdfImages] = useState([]);
  //#endregion

  // 스택형 뒤로가기로 변경: 확인 모달이 열린 동안 뒤로가기를 막음
  useBackStack({
    type: 'block',
    enabled: props.modalToggle2 === true,
    onBack: () => {},
  });

  //#region 이벤트
  //#endregion

  //#region 쿼리
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      const reportData = rows?.[0];
      if (!reportData || reportData?.type === 'Error') {
        console.error('레포트 데이터 조회 실패');
        return;
      }

      setLoading(true);
      const get = (obj, ...keys) =>
        keys.reduce((v, k) => v ?? obj?.[k], undefined);

      let depSignBase64 = null;
      let depSignBase642 = null;
      let depSignBase643 = null;
      let depSignBase644 = null;

      const depPath1 = get(reportData, 'DEP_SIGN_PATH_1', 'depSignPath1');
      if (depPath1) {
        try {
          const imageUrl1 = Global.file.useUrl + 'files/' + depPath1;
          const base64Image1 = await ConvertImageToBase64(imageUrl1);
          depSignBase64 = base64Image1.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase64 = null;
        }
      }

      const depPath2 = get(reportData, 'DEP_SIGN_PATH_2', 'depSignPath2');
      if (depPath2) {
        try {
          const imageUrl2 = Global.file.useUrl + 'files/' + depPath2;
          const base64Image2 = await ConvertImageToBase64(imageUrl2);
          depSignBase642 = base64Image2.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase642 = null;
        }
      }

      const depPath3 = get(reportData, 'DEP_SIGN_PATH_3', 'depSignPath3');
      if (depPath3) {
        try {
          const imageUrl3 = Global.file.useUrl + 'files/' + depPath3;
          const base64Image3 = await ConvertImageToBase64(imageUrl3);
          depSignBase643 = base64Image3.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase643 = null;
        }
      }

      const depPath4 = get(reportData, 'DEP_SIGN_PATH_4', 'depSignPath4');
      if (depPath4) {
        try {
          const imageUrl4 = Global.file.useUrl + 'files/' + depPath4;
          const base64Image4 = await ConvertImageToBase64(imageUrl4);
          depSignBase644 = base64Image4.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          depSignBase644 = null;
        }
      }

      let smSignBase64 = null;
      const smPath = get(
        reportData,
        'SAFETY_SIGNATURE_PATH',
        'safetySignaturePath'
      );
      if (smPath) {
        try {
          const imageUrlSm = Global.file.useUrl + 'files/' + smPath;
          const base64ImageSm = await ConvertImageToBase64(imageUrlSm);
          smSignBase64 = base64ImageSm.replace(
            /^data:image\/[a-z]+;base64,/,
            ''
          );
        } catch (error) {
          smSignBase64 = null;
        }
      }

      const selectedRiskCodes = (
        get(reportData, 'SELECTED_RISK_CODES', 'selectedRiskCodes') || ''
      )
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean);
      const riskItemsList =
        get(reportData, 'RISK_ITEMS_LIST', 'riskItemsList') || '';
      const riskItems = [];
      if (riskItemsList) {
        riskItemsList.split('||').forEach((item) => {
          const [code, name] = item.split('|');
          riskItems.push({
            code: code,
            name: name,
            checked: selectedRiskCodes.includes(code),
          });
        });
      }

      const selectedEquipmentCodes = (
        get(reportData, 'SELECTED_EQUIPMENT_CODES', 'selectedEquipmentCodes') ||
        ''
      )
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean);
      const equipmentItemsList =
        get(reportData, 'EQUIPMENT_ITEMS_LIST', 'equipmentItemsList') || '';
      const equipmentItems = [];
      if (equipmentItemsList) {
        equipmentItemsList.split('||').forEach((item) => {
          const [code, name] = item.split('|');
          equipmentItems.push({
            code: code,
            name: name,
            checked: selectedEquipmentCodes.includes(code),
          });
        });
      }

      const selectedPreparationCodes = (
        get(reportData, 'SELECTED_PREPARATION_CODES', 'selectedPreparationCodes') ||
        ''
      )
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean);
      const preparationItemsList =
        get(reportData, 'PREPARATION_ITEMS_LIST', 'preparationItemsList') || '';
      const preparationItems = [];
      if (preparationItemsList) {
        preparationItemsList.split('||').forEach((item) => {
          const [code, name] = item.split('|');
          preparationItems.push({
            code: code,
            name: name,
            checked: selectedPreparationCodes.includes(code),
          });
        });
      }

      const workTypeCode =
        get(reportData, 'WORK_TYPE_CODE', 'workTypeCode') ||
        get(reportData, 'WORK_TYPE', 'workType') ||
        '';
      const tableDataMain = [
        {
          WT_001: workTypeCode === 'WT_001',
          WT_002: workTypeCode === 'WT_002',
          WT_003: workTypeCode === 'WT_003',
          WT_004: workTypeCode === 'WT_004',
          WT_005: workTypeCode === 'WT_005',
          WT_006: workTypeCode === 'WT_006',
        },
      ];

      const riskRowData = {};
      riskItems.forEach((item, index) => {
        const i = index + 1;
        riskRowData[`RISK_${i}_CHECKED`] = item.checked;
        riskRowData[`RISK_${i}_NAME`] = item.name;
        riskRowData[`RISK_${i}_CODE`] = item.code;
      });
      const riskTableDataHorizontal = [riskRowData];

      const equipmentRowData = {};
      equipmentItems.forEach((item, index) => {
        const i = index + 1;
        equipmentRowData[`EQUIP_${i}_CHECKED`] = item.checked;
        equipmentRowData[`EQUIP_${i}_NAME`] = item.name;
        equipmentRowData[`EQUIP_${i}_CODE`] = item.code;
      });
      const equipmentTableDataHorizontal = [equipmentRowData];

      const validPreparationItems = preparationItems.filter(
        (item) => item && item.code && item.name
      );
      const workList =
        get(reportData, 'WORK_LIST', 'workList') || '';
      let validWorkerNames = workList
        ? workList.split(',').map((n) => n.trim()).filter(Boolean)
        : [];
      const maxRowCount = Math.max(
        validPreparationItems.length,
        validWorkerNames.length
      );
      const preparationTableData = [];
      for (let i = 0; i < maxRowCount; i++) {
        const prepItem =
          i < validPreparationItems.length ? validPreparationItems[i] : null;
        const workerName =
          i < validWorkerNames.length ? validWorkerNames[i] : '';
        preparationTableData.push({
          PREP_CODE: prepItem?.code || '',
          PREP_NAME: prepItem?.name || '',
          PREP_CHECKED: prepItem?.checked || false,
          WORKER_NAME: workerName,
        });
      }

      const permitDate = get(reportData, 'CREATE_DATE', 'createDate')
        ? dayjs(get(reportData, 'CREATE_DATE', 'createDate')).format(
          'YYYY-MM-DD'
        )
        : '';
      const depApproverId =
        get(reportData, 'DEP_APPROVER_ID', 'depApproverId') || '';
      const depApproverIds = depApproverId.split(', ');
      const depApproverIdArray = [];
      for (let i = 0; i < 4; i++) {
        depApproverIdArray.push(depApproverIds[i] || '');
      }

      const headerData = {
        PERMIT_DATE: permitDate,
        PERMIT_NUMBER: get(reportData, 'PM_CD', 'pmCd') || '',
        PERMISSION_DATE: permitDate,
        PERMISSION_NO: get(reportData, 'PM_CD', 'pmCd') || '',
        SITE_NAME: get(reportData, 'SITE_NAME', 'siteName') || '',
        MANAGER_ID: get(reportData, 'MANAGER_ID', 'managerId') || '',
        MANAGER_NAME: get(reportData, 'MANAGER_NAME', 'managerName') || '',
        MANAGER_DEP_CD: get(reportData, 'MANAGER_DEP_CD', 'managerDepCd') || '',
        MANAGER_DEP_NM: get(reportData, 'MANAGER_DEP_NM', 'managerDepNm') || '',
        MANAGER_POSITION: get(reportData, 'MANAGER_POSITION', 'managerPosition') || '',
        MANAGER_PHONE: get(reportData, 'MANAGER_PHONE', 'managerPhone') || '',
        ETC_CONTENT: get(reportData, 'ETC_CONTENT', 'etcContent') || '',
        COMPANY_NAME: get(reportData, 'COMPANY_NAME', 'companyName') || '',
        DEP_NM: get(reportData, 'DEP_NM', 'depNm') || '',
        USER_POSITION: get(reportData, 'USER_POSITION', 'userPosition') || '',
        USER_NAME: get(reportData, 'USER_NAME', 'userName') || '',
        USER_DEP_NM: get(reportData, 'USER_DEP_NM', 'userDepNm') || '',
        WORK_START_DATE: get(reportData, 'WORK_START_DATE', 'workStartDate')
          ? dayjs(get(reportData, 'WORK_START_DATE', 'workStartDate')).format(
            'YYYY-MM-DD HH:mm'
          )
          : '',
        WORK_END_DATE: get(reportData, 'WORK_END_DATE', 'workEndDate')
          ? dayjs(get(reportData, 'WORK_END_DATE', 'workEndDate')).format(
            'YYYY-MM-DD HH:mm'
          )
          : '',
        PLANNED_PERSONNEL:
          get(reportData, 'PLANNED_PERSONNEL', 'plannedPersonnel') ||
          get(reportData, 'PLAN_NUM', 'planNum') ||
          '',
        PLAN_NUM:
          get(reportData, 'PLAN_NUM', 'planNum') ||
          get(reportData, 'PLANNED_PERSONNEL', 'plannedPersonnel') ||
          '',
        NUMBER_OF_WORKERS:
          get(reportData, 'NUMBER_OF_WORKERS', 'numberOfWorkers') || '',
        WORK_LOCATION: get(reportData, 'WORK_LOCATION', 'workLocation') || '',
        WORK_DESCRIPTION:
          get(reportData, 'WORK_DESCRIPTION', 'workDescription') || '',
        WORK_LIST:
          get(reportData, 'WORK_LIST', 'workList') ||
          get(reportData, 'WORK_DESCRIPTION', 'workDescription') ||
          '',
        WORK_TYPE_NAME: get(reportData, 'WORK_TYPE_NAME', 'workTypeName') || '',
        SELECTED_RISK_NAMES:
          get(reportData, 'SELECTED_RISK_NAMES', 'selectedRiskNames') || '',
        PREVENTIVE_MEASURES:
          get(reportData, 'PREVENTIVE_MEASURES', 'preventiveMeasures') || '',
        GUARDIAN: get(reportData, 'GUARDIAN', 'guardian') || '',
        SELECTED_EQUIPMENT_NAMES:
          get(reportData, 'SELECTED_EQUIPMENT_NAMES', 'selectedEquipmentNames') ||
          '',
        SELECTED_PREPARATION_NAMES:
          get(reportData, 'SELECTED_PREPARATION_NAMES', 'selectedPreparationNames') ||
          '',
        OTHER_SPECIAL_NOTES:
          get(reportData, 'OTHER_SPECIAL_NOTES', 'otherSpecialNotes') || '',
        DEP_APPROVAL_STATUS_1:
          get(reportData, 'DEP_APPROVAL_STATUS_1', 'depApprovalStatus1') || '',
        DEP_APPROVER_ID_1: depApproverIdArray[0] || '',
        DEP_APPROVER_NM_1: get(reportData, 'DEP_APPROVER_NM_1', 'depApproverNm1') || '',
        DEP_APPROVER_POSITION_1:
          get(reportData, 'DEP_APPROVER_POSITION_1', 'depApproverPosition1') || '',
        DEP_APPROVER_DEP_NM_1:
          get(reportData, 'DEP_APPROVER_DEP_NM_1', 'depApproverDepNm1') || '',
        DEP_SIGN_PATH_1: depSignBase64,
        DEP_APPROVER_UPDATE_DATE_1: get(
          reportData,
          'DEP_APPROVER_UPDATE_DATE_1',
          'depApproverUpdateDate1'
        )
          ? dayjs(
            get(reportData, 'DEP_APPROVER_UPDATE_DATE_1', 'depApproverUpdateDate1')
          ).format('YYYY/MM/DD')
          : '',
        DEP_APPROVER_ID_2: depApproverIdArray[1] || '',
        DEP_APPROVER_NM_2: get(reportData, 'DEP_APPROVER_NM_2', 'depApproverNm2') || '',
        DEP_APPROVER_POSITION_2:
          get(reportData, 'DEP_APPROVER_POSITION_2', 'depApproverPosition2') || '',
        DEP_APPROVER_DEP_NM_2:
          get(reportData, 'DEP_APPROVER_DEP_NM_2', 'depApproverDepNm2') || '',
        DEP_SIGN_PATH_2: depSignBase642,
        DEP_APPROVER_UPDATE_DATE_2: get(
          reportData,
          'DEP_APPROVER_UPDATE_DATE_2',
          'depApproverUpdateDate2'
        )
          ? dayjs(
            get(reportData, 'DEP_APPROVER_UPDATE_DATE_2', 'depApproverUpdateDate2')
          ).format('YYYY/MM/DD')
          : '',
        DEP_APPROVER_ID_3: depApproverIdArray[2] || '',
        DEP_APPROVER_NM_3: get(reportData, 'DEP_APPROVER_NM_3', 'depApproverNm3') || '',
        DEP_APPROVER_POSITION_3:
          get(reportData, 'DEP_APPROVER_POSITION_3', 'depApproverPosition3') || '',
        DEP_APPROVER_DEP_NM_3:
          get(reportData, 'DEP_APPROVER_DEP_NM_3', 'depApproverDepNm3') || '',
        DEP_SIGN_PATH_3: depSignBase643,
        DEP_APPROVER_UPDATE_DATE_3: get(
          reportData,
          'DEP_APPROVER_UPDATE_DATE_3',
          'depApproverUpdateDate3'
        )
          ? dayjs(
            get(reportData, 'DEP_APPROVER_UPDATE_DATE_3', 'depApproverUpdateDate3')
          ).format('YYYY/MM/DD')
          : '',
        DEP_APPROVER_ID_4: depApproverIdArray[3] || '',
        DEP_APPROVER_NM_4: get(reportData, 'DEP_APPROVER_NM_4', 'depApproverNm4') || '',
        DEP_APPROVER_POSITION_4:
          get(reportData, 'DEP_APPROVER_POSITION_4', 'depApproverPosition4') || '',
        DEP_APPROVER_DEP_NM_4:
          get(reportData, 'DEP_APPROVER_DEP_NM_4', 'depApproverDepNm4') || '',
        DEP_SIGN_PATH_4: depSignBase644,
        DEP_APPROVER_UPDATE_DATE_4: get(
          reportData,
          'DEP_APPROVER_UPDATE_DATE_4',
          'depApproverUpdateDate4'
        )
          ? dayjs(
            get(reportData, 'DEP_APPROVER_UPDATE_DATE_4', 'depApproverUpdateDate4')
          ).format('YYYY/MM/DD')
          : '',
        SAFETY_APPROVAL_STATUS:
          get(reportData, 'SAFETY_APPROVAL_STATUS', 'safetyApprovalStatus') || '',
        SAFETY_APPROVER_ID:
          get(reportData, 'SAFETY_APPROVER_ID', 'safetyApproverId') || '',
        SAFETY_APPROVER_NM:
          get(reportData, 'SAFETY_APPROVER_NM', 'safetyApproverNm') || '',
        SAFETY_APPROVER_POSITION:
          get(reportData, 'SAFETY_APPROVER_POSITION', 'safetyApproverPosition') || '',
        SAFETY_APPROVER_DEP_NM:
          get(reportData, 'SAFETY_APPROVER_DEP_NM', 'safetyApproverDepNm') || '',
        SAFETY_SIGNATURE_PATH: smSignBase64,
        SAFETY_APPROVER_UPDATE_DATE: get(
          reportData,
          'SAFETY_APPROVER_UPDATE_DATE',
          'safetyApproverUpdateDate'
        )
          ? dayjs(
            get(reportData, 'SAFETY_APPROVER_UPDATE_DATE', 'safetyApproverUpdateDate')
          ).format('YYYY/MM/DD')
          : '',
        RETURN_STATUS: get(reportData, 'RETURN_STATUS', 'returnStatus') || '',
        RETURN_REASON: get(reportData, 'RETURN_REASON', 'returnReason') || '',
        RETURN_USER_ID: get(reportData, 'RETURN_USER_ID', 'returnUserId') || '',
        PM_CD: get(reportData, 'PM_CD', 'pmCd'),
        CUST_CD: get(reportData, 'CUST_CD', 'custCd'),
        DEP_CD: get(reportData, 'DEP_CD', 'depCd'),
        USER_ID: get(reportData, 'USER_ID', 'userId'),
      };

      const printData = {
        FileName: 'PER_CUSTOM',
        HeaderData: JSON.stringify(headerData),
        TableDataMain: tableDataMain,
        TableData1: JSON.stringify(riskTableDataHorizontal),
        TableData2: JSON.stringify(equipmentTableDataHorizontal),
        TableData3: JSON.stringify(preparationTableData),
        TableData4: JSON.stringify([]),
        TableData5: JSON.stringify([]),
        TableData6: JSON.stringify([]),
      };

      const pdfRes = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      if (
        !pdfRes?.data ||
        pdfRes?.headers['content-type'] !== 'application/pdf'
      ) {
        throw new Error('PDF 응답이 비어 있거나 PDF가 아닙니다.');
      }

      await RenderPdfToImages(await pdfRes.data.arrayBuffer());
      setLoading(false);
    },
  });
  //#endregion

  //#region 나머지 함수
  const ConvertImageToBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const RenderPdfToImages = async (pdfBlob) => {
    const pdf = await pdfjsLib.getDocument({ data: pdfBlob }).promise;
    const images = [];

    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      await page.render({ canvasContext: context, viewport }).promise;
      images.push(canvas.toDataURL('image/png'));
    }

    setPdfImages(images);
  };

  const GoToPrevPage = () => {
    dispatch(CommonActions.setActiveStep(activeStep - 1));
  };
  //#endregion

  return (
    <M_TBM_CUSTOM_05
      userInfo={userInfo}
      activeStep={activeStep}
      pdfImages={pdfImages}
      loading={loading}
      setActiveStep={(step) => dispatch(CommonActions.setActiveStep(step))}
      check={props.check}
      setCheck={props.setCheck}
      modalToggle2={props.modalToggle2}
      setModalToggle2={props.setModalToggle2}
      ActiveButton={props.ActiveButton}
      goToPrevPage={GoToPrevPage}
    />
  );
}

export default M_TBM_CUSTOM_05F;
